export interface MousePosition {
  mouseX: null | number;
  mouseY: null | number;
}

export enum ResourceSourceType {
  Website = 'Website',
  BOOKS = 'Books',
  JOURNALS = 'Journals',
}

export enum AsyncStatusEnum {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  RESOLVE = 'RESOLVE',
  REJECT = 'REJECT',
}

export enum SearchCategories {
  WEB = 'Web',
  PAPER = 'Paper',
  NEWS = 'News',
}
